//Javascript for the WECAN Employer Area Signup functionality
app.EmployerSignup = (
    function () {
        const signup = {
            //Index Page
            Index: function () {
                $("#btnGenerateSlug").click(function() {
                    const name = $("#DistrictName").val();
                    const url = "/Employer/SignUp/GenerateSlug";
                    const data = {
                        "schoolSystemName": name
                    };
                    $.ajax({
                        type: "POST",
                        url: url,
                        data: data,
                        success: function (slug) {
                            if (slug) {
                                $("#Slug").val(slug);
                            }
                        },
                        error: function (d) {
                            toastr.error("Something went wrong. Please refresh the page and try again.");
                        }
                    });
                });

                if ($("#IsCertifiedManagerSameAsMainUser").is(":checked")) {
                    $("#CertifiedManagerDiv").hide();
                } else {
                    $("#CertifiedManagerDiv").show();
                }

                if ($("#IsSupportManagerSameAsMainUser").is(":checked") ||
                    $("#IsSupportManagerSameAsCertifiedManager").is(":checked")) {
                    $("#SupportManagerDiv").hide();
                } else {
                    $("#SupportManagerDiv").show();
                }

                //Hide the Certified Manager Details if it is the same as the main user
                $("#IsCertifiedManagerSameAsMainUser").on("change",
                    function () {
                        if ($("#IsCertifiedManagerSameAsMainUser").is(":checked")) {
                            $("#CertifiedManagerDiv").hide();
                        }
                        else {
                            $("#CertifiedManagerDiv").show();
                        }
                    });

                //Hide the support manager details if it is the same as the main user
                $("#IsSupportManagerSameAsMainUser").on("change",
                    function () {
                        if ($("#IsSupportManagerSameAsMainUser").is(":checked")) {
                            $("#IsSupportManagerSameAsCertifiedManager").prop("checked", false);
                            $("#SupportManagerDiv").hide();
                        }
                        else {
                            $("#SupportManagerDiv").show();
                        }
                    }
                );
                //Hide the support manager details if it is the same as the cert manager
                $("#IsSupportManagerSameAsCertifiedManager").on("change",
                    function () {
                        if ($("#IsSupportManagerSameAsCertifiedManager").is(":checked")) {
                            $("#IsSupportManagerSameAsMainUser").prop("checked", false);
                            $("#SupportManagerDiv").hide();
                        }
                        else {
                            $("#SupportManagerDiv").show();
                        }
                    }
                );
                function setRequiredIfLabels() {
                    const certifiedManagerSameAsMainUser = $("#IsCertifiedManagerSameAsMainUser").is(":checked");
                    const supportManagerSameAsMainUser = $("#IsSupportManagerSameAsMainUser").is(":checked");
                    const supportManagerSameAsCertifiedManager = $("#IsSupportManagerSameAsCertifiedManager").is(":checked");

                    const certifiedManagerFields = [
                        "#CertifiedVacancyContactFirstName",
                        "#CertifiedVacancyContactLastName",
                        "#CertifiedVacancyContactEmail",
                        "#CertifiedVacancyContactEmailConfirm",
                        "#CertifiedVacancyContactPhoneNumber"
                    ];

                    const supportManagerFields = [
                        "#SupportVacancyContactFirstName",
                        "#SupportVacancyContactLastName",
                        "#SupportVacancyContactEmail",
                        "#SupportVacancyContactEmailConfirm",
                        "#SupportVacancyContactPhoneNumber"
                    ];

                    function updateFields(fields, condition) {
                        fields.forEach(function (field) {
                            const label = $(field).closest("div").find("label");
                            const starString = "<span class='text-danger' data-component-role='requiredstar'>*</span>";
                            if (condition) {
                                $(label).find("span.text-danger").remove();
                            } else {
                                if (!$(label).find("span.text-danger").length) {
                                    $(label).append(starString);
                                }
                            }
                        });
                    }

                    updateFields(certifiedManagerFields, certifiedManagerSameAsMainUser);
                    updateFields(supportManagerFields, supportManagerSameAsMainUser || supportManagerSameAsCertifiedManager);
                }

                // Initial check
                setRequiredIfLabels();
                const starString = "<span class='text-danger' data-component-role='requiredstar'>*</span>";
                $(document).find("label[for=SelectedCESAIds]").append(starString);
                // Event listeners
                $("#IsCertifiedManagerSameAsMainUser, #IsSupportManagerSameAsMainUser, #IsSupportManagerSameAsCertifiedManager").change(function () {
                    setRequiredIfLabels();
                });
            }
        };

        return signup;
    }()
);